/**
 * AuthContext - Wrapper simple pour useAuthPro
 * Permet de garder la compatibilité avec le code existant
 */
import { createContext, useContext } from 'react';
import { useAuthPro } from '../hooks/useAuthPro';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const auth = useAuthPro();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
};
